const NumberHelpers = {
    getCleanNumber: (price: number) => {
        if (price === Infinity || price === -Infinity || isNaN(price)) return null;

        return price;
    },

    interpolate: ({
        x1,
        y1,
        x2,
        y2,
        targetY,
    }: {
        x1: number;
        y1: number;
        x2: number;
        y2: number;
        targetY: number;
    }): number => {
        if (y2 === y1) return (x1 + x2) / 2;

        const interpolationFactor = (targetY - y1) / (y2 - y1);
        return x1 + interpolationFactor * (x2 - x1);
    },

    getPercentageBetweenLimits: ({
        value,
        upperLimit,
        lowerLimit,
    }: {
        value: number;
        upperLimit: number;
        lowerLimit: number;
    }) => {
        if (upperLimit === lowerLimit) return 0;
        if (value < lowerLimit) return 0;
        if (value > upperLimit) return 1;

        return (value - lowerLimit) / (upperLimit - lowerLimit);
    },
};

export { NumberHelpers };
